import Typography from "@mui/material/Typography";

export default function ProTip() {
  return (
    <Typography variant="body3" sx={{ mt: 6, pb: 2, color: "neutral40.main", textAlign: 'center' }}>
      &copy;{" 2024 Big Health [Beta] Version 1.0"}
    </Typography>
  );
}
